import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { addModal } from 'modules/messageSystem/actions/addModal';
import * as modalCodes from 'modules/messageSystem/constants/modalCodes';

import createAction from './';

import { UPDATE_ATTACHMENT } from '../services/editFileMetaDataParameters';

export const EDIT_FILE_META_DATA_PARAMETERS = createAsyncAction(createAction('EDIT_FILE_META_DATA_PARAMETERS'));

const editFileMetadataParameters = ({ id, comment, mimeType }) => (dispatch, getState) => {
  const state = getState();
  const { appointmentId } = state.appointmentInfo.currentAppointment;
  const apiCallParams = {
    mutation: UPDATE_ATTACHMENT,
    variables: {
      metaDataId: id,
      comment,
      appointmentId,
    },
    fetchPolicy: 'no-cache',
  };

  dispatch({ type: EDIT_FILE_META_DATA_PARAMETERS.pending });

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(() => {
      dispatch({
        type: EDIT_FILE_META_DATA_PARAMETERS.success,
        meta: {
          metaDataId: id,
          mimeType,
        },
      });
    })
    .catch((err) => dispatch(errorAction(EDIT_FILE_META_DATA_PARAMETERS.failure, err)));
};

export const editFileMetadataParametersWithConfirm = ({ id, thumbnail, mimeType, comment }) => (dispatch) => {
  return new Promise((resolve, reject) => dispatch(
    addModal({
      testId: 'edit-file-name-modal',
      typeId: modalCodes.MODAL_EDIT_FILE_NAME,
      preventClosingWhenDismiss: true,
      canAddDuplicate: false,
      isForce: true,
      bodyValues: {
        thumbnail,
        mimeType,
        comment,
      },
      onOk: (comment) => resolve(dispatch(editFileMetadataParameters({ id, comment, mimeType }))),
      onCancel: reject,
    }),
  ));
};
